import React from 'react';
import DirectusSDK from '@directus/sdk-js';
import HeadlessConfig from '../config/headless';
import ContactForm from '../components/contact_form';
import { Link } from 'react-router-dom';

import "./d_angebot.css";

const client = new DirectusSDK();
client.login({
  url: HeadlessConfig.url,
  project: HeadlessConfig.project,
  email: HeadlessConfig.email,
  password: HeadlessConfig.password
});

export default class AngebotDetailView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      uuid: this.props.match.params.id,
      item: {},
      isLoaded: false
    }
  }

  componentWillMount() {
    client.getItem('bnb_angebote',this.state.uuid).then(data => {
      this.setState({item: data.data, isLoaded: true});
    }).catch(err => {
      console.error(err);
    })
  }


  convertBinaryToString(binary) {
    if(binary == 1) return "Ja";
    if(binary == 0) return "Nein";
  }

  render() {

    const {uuid, item} = this.state;

    return (
      <div>
        <div className={'d_header'}>
          <Link to="/" className={'go_back_link'}>Zurück zur Übersicht</Link>
        </div>
        <div className={'detail_view'}>
          <div className={'left_view'}>
            <h1 className={'left_title'}>{item.headline}</h1>
            <div className={'about_text'}>
              <div>
                <strong>Über uns/über mich</strong>
                <p>{item.about}</p>
              </div>
            </div>
            <div className={'table_view'}>
              <div>
                <p>Verfügbare Schlafplätze</p>
                <p>{item.number}</p>
              </div>
              <div>
                <p>Bevorzugtes Geschlecht des Gastes:</p>
                <p>{item.gender == "0" && "Weiblich"}
                {item.gender == "1" && "Männlich"}
                {item.gender == "2" && "Egal"}</p>
              </div>
              <div>
                <p>Kinder erlaubt:</p>
                <p>{this.convertBinaryToString(item.kids)}</p>
              </div>
              <div>
                <p>Haustiere erlaubt:</p>
                <p>{this.convertBinaryToString(item.pets)}</p>
              </div>
              <div>
                <p>Rollstuhlgerecht:</p>
                <p>{this.convertBinaryToString(item.accessible)}</p>
              </div>
              <div>
                <p>Schlafraum:</p>
                <p>
                  {item.residential_type == "0" && "Geteiltes Zimmer"}
                  {item.residential_type == "1" && "eigener Raum in einer Wohnung"}  
                  {item.residential_type == "2" && "eigene Wohnung"} 
                </p>
              </div>
              <div>
                <p>Schlafgelegenheit:</p>
                <p>
                  {item.sleeping_accommodation == "0" && "Einzel-Bett"}
                  {item.sleeping_accommodation == "1" && "Doppel-Bett"}
                  {item.sleeping_accommodation == "2" && "Couch"}
                  {item.sleeping_accommodation == "3" && "Matratze auf dem Boden"}
                  {item.sleeping_accommodation == "4" && "Das was man mitbringt"}
                </p>
              </div>
              <div>
                <p>Fahrrad ausleihbar:</p>
                <p>{this.convertBinaryToString(item.bike)}</p>
              </div>
              <div>
                <p>Parkplatz:</p>
                <p>{this.convertBinaryToString(item.parking)}</p>
              </div>
              <div>
                <p>Laufentfernung zur Tübinger Altstadt in Minuten (ca.):</p>
                <p>{item.walking_minutes}</p>
              </div>
            </div>
            <div className={'more_text'}>
              <p><strong>Besonderheiten der Unterkunft:</strong></p>
              <p>{item.more_text}</p>
            </div>
          </div>
          <div className={'right_view'}>
            <ContactForm uuid={uuid} type={"bnb_angebote_kontakt"} inserat={this.state.item} />
          </div>
        </div>
      </div>
      );
  }
}